import React from 'react';
import { Grid, Icon, InputAdornment, TextField, Theme, Tooltip, TooltipProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { makeStyles } from 'tss-react/mui';
import infoIconSvg from 'app/assets/images/infoIcon.svg';
import { RegularRate, holidayFactor, holidayRate } from 'app/models/Placement/PlacementMods';
import { isNumber } from '../../../ModificationsUtils';
import { validDecimal } from 'app/helpers/numberHelper';
import { getInvalidAmount } from '../../BillRate/HourlyRates/BillOrientation';

export const infoIcon = (
  <Icon>
    <img src={infoIconSvg} style={{ marginBottom: '22px' }} />
  </Icon>
);

export const getCalculatedAddedAmount = (getValues, factor, toolTip) => {
  let helperDiv;
  const tooltipText = getValues(factor)
    ? `PSFT automatically adds a 1.0 to the AMIE factor \n Calculation uses PSFT ${toolTip} Factor: 
    ${(parseFloat(getValues(factor)) + 1).toFixed(2)}`
    : '';

  {
    getValues(factor)
      ? (helperDiv = (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            marginLeft: getValues(factor) ? '-4px' : '0px',
          }}
        >
          <div>(Amount = ${(getValues(RegularRate) * (parseFloat(getValues(factor)) + 1)).toFixed(2)})</div>
          <CustomTooltip
            title={tooltipText}
            PopperProps={{
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, -10],
                  },
                },
              ],
            }}
            style={{ marginLeft: '2px' }}
          >
            {infoIcon}
          </CustomTooltip>
        </div>
      ))
      : (helperDiv = (
        <>
          <span>(Amount = ${'0.00'})</span>
        </>
      ));
  }

  return helperDiv;
};

export const HolidayFactor = ({
  classes,
  currentMod,
  isModEdit,
}: {
  classes: any;
  currentMod?: string;
  isModEdit: boolean;
}) => {
  const { t } = useTranslation();
  const { control, getValues, setValue } = useFormContext();
  const holidayFactorWatcher = useWatch<any>({ name: holidayFactor });
  const regularRateValue = useWatch<string>({ name: RegularRate });
  const holidayFactorValue = holidayFactorWatcher !== 0 ? holidayFactorWatcher : null

  return (
    <Grid className={currentMod ? null : classes.rateMargin}>
      <Controller
        name={holidayFactor}
        control={control}
        render={({ field: { onChange, value, ...rest } }) => (
          <TextField
            value={holidayFactorValue}
            variant="filled"
            label={`${t(`placement.placementMods.${holidayFactor}`)}`}
            className={currentMod ? classes.billFactorTextfields : classes.factorTextfields}
            helperText={
              regularRateValue ? getCalculatedAddedAmount(getValues, holidayFactor, 'Holiday') : getInvalidAmount()
            }
            InputLabelProps={{
              shrink: holidayFactorValue,
            }}
            onChange={e => {
              if (validDecimal(e.target.value, { numberLength: 3, decimalLength: 2 })) {
                setValue(holidayFactor, e.target.value);
                onChange(e.target.value);
                setValue(holidayRate, '');
              }
            }}
            InputProps={{
              readOnly: !isModEdit,
              style: {
                pointerEvents: isModEdit ? 'auto' : 'none',
              },
              startAdornment: (
                <>
                  {isNumber(holidayFactorValue) && (
                    <InputAdornment position="start">
                      <CloseIcon className={classes.iconClass} />
                    </InputAdornment>
                  )}
                </>
              ),
            }}
            {...rest}
          />
        )}
      />
    </Grid>
  );
};

const StyledTootltip = makeStyles()((theme: Theme) => ({
  arrow: {
    '&:before': {
      border: '1px solid #E3DFDF',
    },
    color: '#FFFFFF',
  },
  tooltip: {
    minWidth: '6rem',
    fontFamily: 'Roboto',
    fontSize: '12px',
    lineHeight: '18px',
    fontWeight: 'normal',
    color: '#555555',
    backgroundColor: '#FFFFFF',
    border: '1px solid #E3DFDF',
  },
}));

export const CustomTooltip = (props: TooltipProps) => {
  const { classes } = StyledTootltip();

  return <Tooltip arrow enterDelay={500} classes={classes} {...props} />;
};
